import { render, staticRenderFns } from "./main-notice.vue?vue&type=template&id=32d3c0b1&"
import script from "./main-notice.vue?vue&type=script&lang=js&"
export * from "./main-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports